import { FilterComponent } from './tag/filters';
import InfinityScroll from '../components/infinityScroll';
import { updatePriceBlock } from '../components/utilities.js';
import setTopBar from '../components/topBar.js';
import ReactiveSearch from '../components/reactiveSearch.js';

const Tag = {
  init: function () {
    setTopBar();
    FilterComponent.init();
    updatePriceBlock();
    InfinityScroll.init();
    ReactiveSearch.init();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Tag.init();
});
